
import moment from "moment";
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import intl from 'react-intl-universal';
export const GET_PROPS_LIST = "GET_PROPS_LIST";
export const GET_OPERATION_LIST = "GET_OPERATION_LIST";
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const UPDATE_DATA_TYPE = "UPDATE_DATA_TYPE";
moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

export function updateDataTpe(dataType) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_DATA_TYPE,
      dataType
    });
  };
}

export function getPropsList(id) {
  return (dispatch, getState) => {
    const defaultParam = {
      offset: 0,
      limit: 100000,
      fType: 0
    };
    dispatch({
      type: GET_PROPS_LIST,
      propsList: [],
    });
    dispatch(updateLoadingStatus(true));
    const fetchData = new FetchData(`/iot/feature/open/iot-feature-manager/console/${id}/attribute`, {
      method: "GET",
      body: defaultParam,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        dispatch(updateLoadingStatus(false));
        if (data.meta.code == 200) {
          dispatch({
            type: GET_PROPS_LIST,
            propsList: data.data ? data.data.resultList || [] : [],
            total: data.data ? data.data.totalResults || 0 : 0
          });
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}

export function addProps(params, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      compatible: 0,
      itemType: "standard"
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/feature/open/iot-feature-manager/console/${params.id}/attribute`, {
      method: "POST",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.meta.code == 200) {
          callback();
        } else {
          message.error(data.meta.message || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

export function editProps(params, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      productLine: "ys",
      compatible: 0,
      itemType: "standard"
    };
    const req = Object.assign({}, defaultParam, params);
    const fetchData = new FetchData(`/iot/feature/open/iot-feature-manager/console/${params.domainId}/attribute`, {
      method: "PUT",
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.meta.code == 200) {
          callback();
        } else {
          message.error(data.meta.message || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}

export function deleteProps(params, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
      productLine: "ys"
    };
    const fetchData = new FetchData(`/iot/feature/open/iot-feature-manager/console/${params.domainId}/attribute?fid=${params.id}`, {
      method: "DELETE",
      body: {},
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        if (data.meta.code === 200) {
          callback();
          message.success(intl.get('commmon.operate.deleteSuccess'));
        } else {
          message.error(data.meta.message || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}
